import React from 'react';
import { Hero } from '../components/vsl/Hero';
import { PainSection } from '../components/vsl/PainSection';
import { MethodSection } from '../components/vsl/MethodSection';
import { ModulesSection } from '../components/vsl/ModulesSection';
import { BonusSection } from '../components/vsl/BonusSection';
import { TestimonialsSection } from '../components/vsl/TestimonialsSection';
import { OfferSection } from '../components/vsl/OfferSection';
import { FaqSection } from '../components/vsl/FaqSection';
import { StickyCta } from '../components/vsl/StickyCta';
import { SiteFooter } from '../components/vsl/SiteFooter';
type CurlySeduccionProps = {
  showTestimonials: boolean;
  showStickyCta: boolean;
};
export function CurlySeduccion({
  showTestimonials,
  showStickyCta
}: CurlySeduccionProps) {
  return <div className="w-full bg-ink font-sans" data-id="element-153" data-mp="1lrsad8zfzzd9">
      <Hero data-id="element-154" data-mp="1lsjtvlfrm6n6" />
      <main data-id="element-155" data-mp="1ltblkl68rk86">
        <PainSection data-id="element-156" data-mp="1h0ilwbpmr22y" />
        <MethodSection data-id="element-157" data-mp="1h00i8u0n1ll0" />
        <ModulesSection data-id="element-158" data-mp="1gzqp4xkaqyb3" />
        <BonusSection data-id="element-159" data-mp="1gyfkkvj11mix" />
        {showTestimonials && <TestimonialsSection data-id="element-160" data-mp="gfhm1iuk00b9" />}
        <OfferSection data-id="element-161" data-mp="ggj7mh974578" />
        <FaqSection data-id="element-162" data-mp="gi41e4nork41" />
      </main>
      <SiteFooter data-id="element-163" data-mp="lfm1r6nn0r0f" />
      {showStickyCta && <StickyCta data-id="element-164" data-mp="ldswnvsoaeuj" />}
    </div>;
}